import { Inject, injectable } from 'inversify-props';
import { BaseAPIService } from './base-api.service';
import { AdminUserModel } from '@/models/DTO/admin/admin-user.model';

const API_VERSION: string = process.env.VUE_APP_API_VERSION;
const ADMIN_USER_URL_STUB = `/api/v${API_VERSION}/AdminUser`;
const GET_ADMIN_USER_BY_ID_URL = `/api/v${API_VERSION}/AdminUser/:id`;
const ADMIN_USER_LOCK_URL = `/api/v${API_VERSION}/AdminUser/Lock/:id`;
const ADMIN_USER_UNLOCK_URL = `/api/v${API_VERSION}/AdminUser/Unlock/:id`;

export interface AdminUserService {
  getAllAdminUsers(): Promise<AdminUserModel[]>;
  getAdminUserById(id: string): Promise<AdminUserModel>;
  lockAdminUser(id: string): Promise<void>;
  unlockAdminUser(id: string): Promise<void>;
}

@injectable()
export class AdminUserService implements AdminUserService {
  @Inject()
  private readonly _baseAPIService!: BaseAPIService;

  public async getAllAdminUsers(): Promise<AdminUserModel[]> {
    const resp = await this._baseAPIService.client.get<AdminUserModel[]>(
      ADMIN_USER_URL_STUB
    );
    return resp.data;
  }

  public async getAdminUserById(id: string): Promise<AdminUserModel> {
    const resp = await this._baseAPIService.client.get<AdminUserModel>(
      GET_ADMIN_USER_BY_ID_URL.replace(':id', id)
    );
    return resp.data;
  }

  public async lockAdminUser(id: string): Promise<void> {
    await this._baseAPIService.client.get(
      ADMIN_USER_LOCK_URL.replace(':id', id)
    );
  }

  public async unlockAdminUser(id: string): Promise<void> {
    await this._baseAPIService.client.get(
      ADMIN_USER_UNLOCK_URL.replace(':id', id)
    );
  }
}
